import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const Descriptions = {
  parts: ['Header', 'Title', 'Extra', 'Grid', 'GridItem', 'Label', 'Content'],
  baseStyle: (props: StyleFunctionProps) => ({
    Header: { mb: 5, color: mode('black', 'white')(props) },
    Title: {
      fontWeight: 'bold',
      overflow: 'hidden',
      fontSize: 'md',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      color: mode('black', 'white')(props),
    },
    Extra: {
      ml: 'auto',
      marginStart: 'auto !important',
      fontSize: 'sm',
    },
    Grid: {
      gridTemplateColumns: `repeat(${props.column}, 1fr)`,
      color: mode('black', 'white')(props),
    },
    GridItem: {
      display: props.layout === 'horizontal' ? 'flex' : 'block',
    },
    Label: {
      ...(props.bordered
        ? {
            border: '1px solid',
            borderColor: mode('gray.300', 'white')(props),
          }
        : {}),
      h: props.layout === 'horizontal' ? '100%' : '50%',
      w: props.layout === 'horizontal' ? '50%' : '100%',
      bg: mode('gray.100', 'gray.700')(props),
      ...(props.size === 'default'
        ? { py: 4, px: 6 }
        : props.size === 'middle'
        ? { py: 2, px: 3 }
        : { py: 1, px: 1.5 }),
    },
    Content: {
      ...(props.bordered
        ? {
            border: '1px solid',
            borderColor: mode('gray.300', 'white')(props),
          }
        : {}),
      h: props.layout === 'horizontal' ? '100%' : '50%',
      w: props.layout === 'horizontal' ? '50%' : '100%',
      ...(props.size === 'default'
        ? { py: 4, px: 6 }
        : props.size === 'middle'
        ? { py: 2, px: 3 }
        : { py: 1, px: 1.5 }),
    },
  }),
};

export default Descriptions;
